import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primaryGreen: '#4E923A',
                primaryDarkGreen: '#006847',
                primaryBlue: '#8dd7f7',
                primaryDarkBlue: '#003B5C',
                secondaryTeal: '#00aab8',
                secondaryBlue1: '#009ada',
                secondaryDarkBlue: '#00395c',
                secondaryBlue2: '#8dd7f7',
                secondaryBlue3: '#00aeef',
                secondaryYellow1: '#e0e457',
                secondaryGreen: '#94ca4e',
                secondaryDarkGreen: '#2b953e',
                secondaryYellow2: '#ffdf01',
                secondaryOrange: '#f9a31b',
                secondaryRed: '#f26935',
                secondaryPink: '#ee1059',
                secondaryPurple: '#ab2e92',
                secondaryDarkPurple: '#603e99',
                green: '#4E923A',
                blue: '#003B5C',
            },
        },
        options: {
            customProperties: true,
        },
    },
});
